export default {"src":"https://assets.madeeasy.in/prod/_next/static/media/bookmark_fillnew.a69086d4.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};